// src/actions/organizationActions.js

import {
  fetchOrganisations as fetchOrganisationsAPI,
  addOrganization as addOrganizationAPI,
  updateOrganization as updateOrganizationAPI,
  saveOpenAIKeyAPI,
  getOpenAIKeyAPI,
  deleteOpenAIKeyAPI, // import the update API
} from '../apis/index';

import axiosInstance from '../apis/axiosInstance';
import { fetchOrganizationDetailsAPI } from '../apis/index';

export const FETCH_ORGANISATIONS_REQUEST = 'FETCH_ORGANISATIONS_REQUEST';
export const FETCH_ORGANISATIONS_SUCCESS = 'FETCH_ORGANISATIONS_SUCCESS';
export const FETCH_ORGANISATIONS_FAILURE = 'FETCH_ORGANISATIONS_FAILURE';

export const ADD_ORGANIZATION_REQUEST = 'ADD_ORGANIZATION_REQUEST';
export const ADD_ORGANIZATION_SUCCESS = 'ADD_ORGANIZATION_SUCCESS';
export const ADD_ORGANIZATION_FAILURE = 'ADD_ORGANIZATION_FAILURE';

export const UPDATE_ORGANIZATION_REQUEST = 'UPDATE_ORGANIZATION_REQUEST';
export const UPDATE_ORGANIZATION_SUCCESS = 'UPDATE_ORGANIZATION_SUCCESS';
export const UPDATE_ORGANIZATION_FAILURE = 'UPDATE_ORGANIZATION_FAILURE';

export const FETCH_ORGANIZATION_DETAILS_REQUEST = 'FETCH_ORGANIZATION_DETAILS_REQUEST';
export const FETCH_ORGANIZATION_DETAILS_SUCCESS = 'FETCH_ORGANIZATION_DETAILS_SUCCESS';
export const FETCH_ORGANIZATION_DETAILS_FAILURE = 'FETCH_ORGANIZATION_DETAILS_FAILURE';

export const ADD_STAR_RATING_REQUEST = 'STAR_RATING_REQUEST';
export const ADD_STAR_RATING_SUCCESS = 'STAR_RATING_SUCCESS';
export const ADD_STAR_RATING_FAILURE = 'STAR_RATING_FAILURE';

export const UPDATE_STAR_RATING_REQUEST = 'UPDATE_STAR_RATING_REQUEST';
export const UPDATE_STAR_RATING_SUCCESS = 'UPDATE_STAR_RATING_SUCCESS';
export const UPDATE_STAR_RATING_FAILURE = 'UPDATE_STAR_RATING_FAILURE';

export const FETCH_STAR_RATING_REQUEST = 'FETCH_STAR_RATING_REQUEST';
export const FETCH_STAR_RATING_SUCCESS = 'FETCH_STAR_RATING_SUCCESS';
export const FETCH_STAR_RATING_FAILURE = 'FETCH_STAR_RATING_FAILURE';

export const SAVE_OPENAI_KEY_REQUEST = "SAVE_OPENAI_KEY_REQUEST";
export const SAVE_OPENAI_KEY_SUCCESS = "SAVE_OPENAI_KEY_SUCCESS";
export const SAVE_OPENAI_KEY_FAILURE = "SAVE_OPENAI_KEY_FAILURE";

export const GET_OPENAI_KEY_REQUEST = "GET_OPENAI_KEY_REQUEST";
export const GET_OPENAI_KEY_SUCCESS = "GET_OPENAI_KEY_SUCCESS";
export const GET_OPENAI_KEY_FAILURE = "GET_OPENAI_KEY_FAILURE";

export const DELETE_OPENAI_KEY_REQUEST = "DELETE_OPENAI_KEY_REQUEST";
export const DELETE_OPENAI_KEY_SUCCESS = "DELETE_OPENAI_KEY_SUCCESS";
export const DELETE_OPENAI_KEY_FAILURE = "DELETE_OPENAI_KEY_FAILURE";

const saveOpenAIKeyRequest = () => ({
  type: SAVE_OPENAI_KEY_REQUEST,
});

export const getOpenAIKey = () => async (dispatch) => {
  dispatch({ type: GET_OPENAI_KEY_REQUEST });
  try {
    const response = await getOpenAIKeyAPI();
    dispatch({
      type: GET_OPENAI_KEY_SUCCESS,
      payload: response.data,
    });
    return { status: response.status, data: response.data };
  } catch (error) {
    dispatch({
      type: GET_OPENAI_KEY_FAILURE,
      payload: error.message,
    });
    return { status: error.response ? error.response.status : 400, error: error.message };
  }
};

// Delete OpenAI Key
export const deleteOpenAIKey = () => {
  return async (dispatch) => {
    dispatch({ type: DELETE_OPENAI_KEY_REQUEST });
    try {
      await deleteOpenAIKeyAPI();
      dispatch({ type: DELETE_OPENAI_KEY_SUCCESS });
      return { status: 200 };
    } catch (error) {
      dispatch({ type: DELETE_OPENAI_KEY_FAILURE, payload: error.message });
      return { status: error.response ? error.response.status : 400, error: error.message };
    }
  };
};

const saveOpenAIKeySuccess = (status) => ({
  type: SAVE_OPENAI_KEY_SUCCESS,
  payload: status,
});

const saveOpenAIKeyFailure = (error) => ({
  type: SAVE_OPENAI_KEY_FAILURE,
  payload: error,
});

// Action Creator to Save OpenAI Key
export const saveOpenAIKey = (apiKey) => {
  return async (dispatch) => {
    dispatch(saveOpenAIKeyRequest());
    try {
      // Call the API with the API key (or encrypted payload, if using encryption)
      const response = await saveOpenAIKeyAPI({ openAIKey: apiKey });
      dispatch(saveOpenAIKeySuccess(response.status));
      return { status: response.status, data: response.data };
    } catch (error) {
      const status = error.response ? error.response.status : 400;
      dispatch(saveOpenAIKeyFailure(error.message));
      return { status, error: error.message };
    }
  };
};

const fetchOrganisationsRequest = () => ({
  type: FETCH_ORGANISATIONS_REQUEST,
});

const fetchOrganisationsSuccess = (organisations) => ({
  type: FETCH_ORGANISATIONS_SUCCESS,
  payload: organisations,
});

const fetchOrganisationsFailure = (error) => ({
  type: FETCH_ORGANISATIONS_FAILURE,
  payload: error,
});

export const fetchOrganisations = () => {
  return async (dispatch) => {
    dispatch(fetchOrganisationsRequest());
    try {
      const organisations = await fetchOrganisationsAPI();
      dispatch(fetchOrganisationsSuccess(organisations));
    } catch (error) {
      dispatch(fetchOrganisationsFailure(error.message));
    }
  };
};

const addOrganizationRequest = () => ({
  type: ADD_ORGANIZATION_REQUEST,
});

const addOrganizationSuccess = (organization, status) => ({
  type: ADD_ORGANIZATION_SUCCESS,
  payload: { organization, status },
});

const addOrganizationFailure = (error) => ({
  type: ADD_ORGANIZATION_FAILURE,
  payload: error,
});

export const addOrganization = (organizationData) => {
  return async (dispatch, getState) => {
    dispatch(addOrganizationRequest());
    try {
      const response = await addOrganizationAPI(organizationData);
      dispatch(addOrganizationSuccess(response.data, response.status));
    } catch (error) {
      dispatch(addOrganizationFailure(error.message));
    }
  };
};

export const RESET_ADD_ORGANIZATION_STATUS = 'RESET_ADD_ORGANIZATION_STATUS';

export const resetAddOrganizationStatus = () => ({
  type: RESET_ADD_ORGANIZATION_STATUS,
});

// New actions for updating an organization
const updateOrganizationRequest = () => ({
  type: UPDATE_ORGANIZATION_REQUEST,
});

const updateOrganizationSuccess = (organization, status) => ({
  type: UPDATE_ORGANIZATION_SUCCESS,
  payload: { organization, status },
});

const updateOrganizationFailure = (error) => ({
  type: UPDATE_ORGANIZATION_FAILURE,
  payload: error,
});

export const updateOrganization = (organizationData) => {
  return async (dispatch) => {
    dispatch(updateOrganizationRequest());
    try {
      const response = await updateOrganizationAPI(organizationData);
      dispatch(updateOrganizationSuccess(response.data, response.status));
    } catch (error) {
      dispatch(updateOrganizationFailure(error.message));
    }
  };
};

export const RESET_UPDATE_ORGANIZATION_STATUS = 'RESET_UPDATE_ORGANIZATION_STATUS';

export const resetUpdateOrganizationStatus = () => ({
  type: RESET_UPDATE_ORGANIZATION_STATUS,
});

const fetchOrganizationDetailsRequest = () => ({
  type: FETCH_ORGANIZATION_DETAILS_REQUEST,
});

const fetchOrganizationDetailsSuccess = (details) => ({
  type: FETCH_ORGANIZATION_DETAILS_SUCCESS,
  payload: details,
});

const fetchOrganizationDetailsFailure = (error) => ({
  type: FETCH_ORGANIZATION_DETAILS_FAILURE,
  payload: error,
});

export const fetchOrganizationDetails = (forceRefresh = false) => {
  return async (dispatch) => {
    dispatch(fetchOrganizationDetailsRequest());
    try {
      // Try loading from cache first
      if (!forceRefresh) {
        const cached = localStorage.getItem('orgDetails');
        const cachedTime = localStorage.getItem('orgDetailsTime');
        if (cached && cachedTime) {
          const age = Date.now() - parseInt(cachedTime, 10);
          // Use cache if less than 10 minutes old
          if (age < 600000) {
            dispatch(fetchOrganizationDetailsSuccess(JSON.parse(cached)));
            return;
          }
        }
      }
      const details = await fetchOrganizationDetailsAPI();
      // Cache the response
      try {
        localStorage.setItem('orgDetails', JSON.stringify(details));
        localStorage.setItem('orgDetailsTime', Date.now().toString());
      } catch (e) {
        // localStorage full or unavailable, ignore
      }
      dispatch(fetchOrganizationDetailsSuccess(details));
    } catch (error) {
      // Fall back to cache on network error
      const cached = localStorage.getItem('orgDetails');
      if (cached) {
        dispatch(fetchOrganizationDetailsSuccess(JSON.parse(cached)));
      } else {
        dispatch(fetchOrganizationDetailsFailure(error.message));
      }
    }
  };
};

// Action Creators for Star Rating
const addStarRatingRequest = () => ({
  type: ADD_STAR_RATING_REQUEST,
});

const addStarRatingSuccess = (rating) => ({
  type: ADD_STAR_RATING_SUCCESS,
  payload: rating,
});

const addStarRatingFailure = (error) => ({
  type: ADD_STAR_RATING_FAILURE,
  payload: error,
});

const updateStarRatingRequest = () => ({
  type: UPDATE_STAR_RATING_REQUEST,
});

const updateStarRatingSuccess = (rating) => ({
  type: UPDATE_STAR_RATING_SUCCESS,
  payload: rating,
});

const updateStarRatingFailure = (error) => ({
  type: UPDATE_STAR_RATING_FAILURE,
  payload: error,
});

const fetchStarRatingRequest = () => ({
  type: FETCH_STAR_RATING_REQUEST,
});

const fetchStarRatingSuccess = (rating) => ({
  type: FETCH_STAR_RATING_SUCCESS,
  payload: rating,
});

const fetchStarRatingFailure = (error) => ({
  type: FETCH_STAR_RATING_FAILURE,
  payload: error,
});

// Thunks for Star Rating
export const addStarRating = (rating) => {
  return async (dispatch) => {
    dispatch(addStarRatingRequest());
    try {
      const response = await addStarRatingAPI(rating);
      dispatch(addStarRatingSuccess(response));
    } catch (error) {
      dispatch(addStarRatingFailure(error.message));
    }
  };
};

export const updateStarRating = (rating) => {
  return async (dispatch) => {
    dispatch(updateStarRatingRequest());
    try {
      const response = await updateStarRatingAPI(rating);
      dispatch(updateStarRatingSuccess(response));
    } catch (error) {
      dispatch(updateStarRatingFailure(error.message));
    }
  };
};

export const fetchStarRating = () => {
  return async (dispatch) => {
    dispatch(fetchStarRatingRequest());
    try {
      const response = await fetchStarRatingAPI();
      dispatch(fetchStarRatingSuccess(response));
    } catch (error) {
      dispatch(fetchStarRatingFailure(error.message));
    }
  };
};
